import { Box, CircularProgress, Typography } from '@mui/material';

export const LoadingState = () => {
    return (
        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column',
            justifyContent: 'center', 
            alignItems: 'center', 
            padding: '60px',
            gap: 2
        }}>
            <CircularProgress size={40} thickness={4} sx={{ color: '#667eea' }} />
            <Typography sx={{ color: '#64748b', fontSize: '0.95rem' }}>
                Loading plan details...
            </Typography>
        </Box>
    );
};
